/*
 * Prevent unnecessary revalidation of route loaders in React Router 7.
 *
 * In RR7, all navigations — including those caused by search params or hash changes - will trigger route loaders to re-run by default.
 * This behavior differs from client/server apps, where SSR data loaders are only executed when the page is actually reloaded.
 *
 * During the Web Foundations Stage 4.1, we are intentionally keeping loaders running only on full page reloads.
 *
 * By exporting this function as `shouldRevalidate` from each route, we ensure that loaders do not re-run
 * on navigations that do not require a full page reload.
 *
 * Reference: https://reactrouter.com/start/framework/route-module#shouldrevalidate
 */
export const shouldRevalidateProvider = () => false;
